import { render, staticRenderFns } from "./CreateNewCustomer.vue?vue&type=template&id=5cf6e230&scoped=true"
import script from "./CreateNewCustomer.vue?vue&type=script&lang=ts"
export * from "./CreateNewCustomer.vue?vue&type=script&lang=ts"
import style0 from "./CreateNewCustomer.vue?vue&type=style&index=0&id=5cf6e230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6e230",
  null
  
)

export default component.exports